const StatDictionary = {
    0: "HP",
    1: "Attack",
    2: "Defense",
    3: "Sp. Attack",
    4: "Sp. Defense",
    5: "Speed"
};

export default StatDictionary;